import React, { Component } from 'react';
import { Modal, message, Select } from 'antd';
import { Form } from '@ant-design/compatible';
import { Icon } from '@iconify/react';

import DadosPessoais from './DadosPessoais';
import { post, update, find } from '../../../shared/services/http/UsuarioService';
import { withAppInsightsTracking } from '../../../shared/services/AppInsightsService';
import { MenuFuncionarioEnum } from '../../../shared/Enum/MenuFuncionarioEnum';
import './UsuarioFormulario.scss';

class UsuarioFormulario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenusChanged: false,
      selectedMenus: [],
      loading: false,
      user: this.props.user,
    };
  }

  beforeClose = (user) => {
    this.setState({ selectedMenus: [] });
    this.props.form.resetFields();
    this.props.form.validateFields();
    this.props.onClose({
      reset: this.props.form.resetFields,
      user,
    });
  };

  toggleLoading = (callBack) =>
    this.setState((prevState) => ({ loading: !prevState.loading }), callBack);

  create = async (values) => {
    try {
      await post(values);
      this.toggleLoading(() => {
        this.beforeClose();
        message.success('Usuário criado com sucesso!');
      });
    } catch (error) {
      this.toggleLoading(() => message.error(error));
    }
  };

  update = async (values) => {
    try {
      await update(values);
      const user = await find(values.id);
      this.toggleLoading(() => {
        this.beforeClose(user);
        message.success('Usuário atualizado com sucesso!');
      });
    } catch (error) {
      this.toggleLoading(() => message.error(error));
    }
  };

  handleSubmit = () => {
    this.props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        this.toggleLoading(() => {
          const { user } = this.props;
          const { selectedMenus } = this.state;
          if (user.id) {
            this.update({ ...values, id: user.id, menu: selectedMenus });
          } else {
            this.create({ ...values, menu: selectedMenus });
          }
        });
      }
    });
  };

  menuSelectChange = (value) => {
    this.setState({ selectedMenus: value, selectedMenusChanged: true });
    this.props.form.validateFields();
  };

  render() {
    const { isOpen, form, user } = this.props;
    const { loading, selectedMenus } = this.state;

    const menuValue =
      selectedMenus.length > 0
        ? selectedMenus
        : user.menu && user.menu.length > 0
          ? user.menu
          : [];

    return (
      <Modal
        visible={isOpen}
        onCancel={() => this.beforeClose()}
        footer={null}
        closable={false}
        width={922}
        className='uf-modal'
        destroyOnClose>
        <div className='uf__header'>
          <div className='uf__title-row'>
            <div className='uf__icon-box'>
              <Icon icon='ph:user-fill' width={17} height={17} />
            </div>
            <span className='uf__title'>
              {user.id ? 'Editar Usuário' : 'Novo Usuário'}
            </span>
          </div>
          <button className='uf__close' onClick={() => this.beforeClose()}>
            <Icon icon='fa6-solid:xmark' fontSize={20} />
          </button>
        </div>

        <div className='uf__body'>
          <div>
            <p className='uf__section-title'>Informações Pessoais</p>
            <DadosPessoais user={user} form={form} ref={this.dadosPessoais} />
          </div>

          <div>
            <p className='uf__section-title'>Acesso</p>
            <div className='uf__field'>
              <label className='uf__field-label'>Menus</label>
              <Select
                value={menuValue}
                mode='multiple'
                placeholder='Selecione quais menus o usuário pode acessar'
                onChange={this.menuSelectChange}
                className='uf__menu-select'
                tagRender={() => null}>
                {MenuFuncionarioEnum.map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>
                    {opt.text}
                  </Select.Option>
                ))}
              </Select>
              {menuValue.length > 0 && (
                <div className='uf__menu-tags'>
                  {menuValue.map((value) => {
                    const opt = MenuFuncionarioEnum.find(
                      (o) => o.value === value,
                    );
                    return (
                      <span key={value} className='uf__menu-tag'>
                        {opt?.text}
                        <button
                          className='uf__menu-tag-remove'
                          onClick={() =>
                            this.menuSelectChange(
                              menuValue.filter((v) => v !== value),
                            )
                          }>
                          ×
                        </button>
                      </span>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

          <div className='uf__footer'>
            <button
              className='uf__btn uf__btn--outline'
              onClick={() => this.beforeClose()}>
              Cancelar
            </button>
            <button
              className='uf__btn uf__btn--filled'
              onClick={this.handleSubmit}
              disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

UsuarioFormulario = Form.create()(UsuarioFormulario);

export default withAppInsightsTracking(UsuarioFormulario);
